import {
    autoBatchEnhancer,
    combineReducers,
    configureStore,
} from '@reduxjs/toolkit'
import {
    batchMiddleware,
    eventMiddleware,
    filterMiddleware,
    sessionlessMiddleware,
} from '../middlewares/ninchat'
import {init as appInit} from 'app'
import {appMiddleware} from '../middlewares/app'
import {enhancers} from './enhancers'
import {getState} from './storage'
import {jitsiReducer} from '../reducers/jitsi'
import {listenerMiddleware} from 'middlewares/listener'
import {modalMiddleware} from 'middlewares/modal'
import {modalReducer} from '../reducers/modal'
import {navigationReducer} from '../navigation/slice'
import ninchatClient from '../api/NinchatClient'
import {ninchatReducer} from 'api/slice'
import {uiMiddleware} from '../middlewares/ui'
import {uiReducer} from '../state/ui'

const rootReducer = combineReducers({
    jitsi: jitsiReducer,
    modal: modalReducer,
    navigation: navigationReducer,
    ninchat: ninchatReducer,
    ui: uiReducer,
})

const initialState = () => {
    const reducerState = rootReducer(undefined, {type: ''})
    const storageState = getState()

    const merge = (_a: object, _b: object = {}) => {
        const a = {..._a} as Record<string, unknown>
        const b = {..._b} as Record<string, unknown>

        for (const key of Object.keys(b)) {
            if (a[key] && b[key]?.constructor === Object) {
                a[key] = merge(a[key] as object, b[key] as object)
            } else {
                a[key] = b[key]
            }
        }

        return a
    }

    return merge(reducerState, storageState)
}

export const store = configureStore({
    enhancers: (defaultEnhancers) => [...enhancers, ...defaultEnhancers, autoBatchEnhancer({
        timeout: 15000,
        type: 'timer',
    })],
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: {ignoredActionPaths: ['meta.reducer', 'meta.arg.file', 'payload.file']}})
        .prepend(
            appMiddleware,
            filterMiddleware,
            modalMiddleware,
            uiMiddleware,
            sessionlessMiddleware,
            eventMiddleware,
            batchMiddleware,
            listenerMiddleware,
        ),
    preloadedState: initialState(),
    reducer: rootReducer,
})

ninchatClient.dispatch = store.dispatch

store.dispatch(appInit())

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
